var _path, _g, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShared(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 13.3125C10.6805 13.3125 9.60547 12.2375 9.60547 10.9166C9.60547 9.59581 10.6805 8.52081 12.0013 8.52081C13.3221 8.52081 14.3971 9.59581 14.3971 10.9166C14.3971 12.2375 13.3221 13.3125 12.0013 13.3125ZM12.0013 9.14581C11.0263 9.14581 10.2305 9.94165 10.2305 10.9166C10.2305 11.8916 11.0263 12.6875 12.0013 12.6875C12.9763 12.6875 13.7721 11.8916 13.7721 10.9166C13.7721 9.94165 12.9763 9.14581 12.0013 9.14581Z",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1676_107220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5802 18.4792C15.4094 18.4792 15.2677 18.3375 15.2677 18.1667C15.2677 16.7292 13.801 15.5625 12.001 15.5625C10.201 15.5625 8.73438 16.7292 8.73438 18.1667C8.73438 18.3375 8.59271 18.4792 8.42188 18.4792C8.25104 18.4792 8.10938 18.3375 8.10938 18.1667C8.10938 16.3875 9.85521 14.9375 12.001 14.9375C14.1469 14.9375 15.8927 16.3875 15.8927 18.1667C15.8927 18.3375 15.751 18.4792 15.5802 18.4792Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5802 18.4792C15.4094 18.4792 15.2677 18.3375 15.2677 18.1667C15.2677 16.7292 13.801 15.5625 12.001 15.5625C10.201 15.5625 8.73438 16.7292 8.73438 18.1667C8.73438 18.3375 8.59271 18.4792 8.42188 18.4792C8.25104 18.4792 8.10938 18.3375 8.10938 18.1667C8.10938 16.3875 9.85521 14.9375 12.001 14.9375C14.1469 14.9375 15.8927 16.3875 15.8927 18.1667C15.8927 18.3375 15.751 18.4792 15.5802 18.4792Z",
    strokeWidth: 0.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22.75H7C2.59 22.75 1.25 21.41 1.25 17V7C1.25 2.59 2.59 1.25 7 1.25H8.5C10.25 1.25 10.8 1.82 11.5 2.75L13 4.75C13.33 5.19 13.38 5.25 14 5.25H17C21.41 5.25 22.75 6.59 22.75 11V17C22.75 21.41 21.41 22.75 17 22.75ZM7 2.75C3.42 2.75 2.75 3.43 2.75 7V17C2.75 20.57 3.42 21.25 7 21.25H17C20.58 21.25 21.25 20.57 21.25 17V11C21.25 7.43 20.58 6.75 17 6.75H14C12.72 6.75 12.3 6.31 11.8 5.65L10.3 3.65C9.78 2.96 9.62 2.75 8.5 2.75H7V2.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.13C19.59 7.13 19.25 6.79 19.25 6.38V5C19.25 3.42 18.58 2.75 17 2.75H8C7.59 2.75 7.25 2.41 7.25 2C7.25 1.59 7.59 1.25 8 1.25H17C19.42 1.25 20.75 2.58 20.75 5V6.38C20.75 6.79 20.41 7.13 20 7.13Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1676_107220",
    x: 3.85938,
    y: 14.6875,
    width: 16.2852,
    height: 12.0417,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1676_107220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1676_107220",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShared);
export default __webpack_public_path__ + "static/media/Shared.34cc34aba71afc7c6389fa0f8934bc58.svg";
export { ForwardRef as ReactComponent };